import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import { KHeaderWidgetComponentContext } from "../models";

const PREFIX = "KHeaderWidgetActionsBox";

export const classes = {
  root: `${PREFIX}-root`,
  button: `${PREFIX}-button`,
  customLink: `${PREFIX}-customLink`,
  buttonHome: `${PREFIX}-buttonHome`,
  iconHome: `${PREFIX}-iconHome`,
  searchBar: `${PREFIX}-searchBar`,
  langSelector: `${PREFIX}-langSelector`,
  user: `${PREFIX}-user`,
  userTitle: `${PREFIX}-userTitle`,
};

const StyledKHeaderWidgetActionsBox = styled(Box)<{ context: KHeaderWidgetComponentContext }>(
  ({ theme, context = KHeaderWidgetComponentContext.All }) => ({
    [`&.${classes.root}`]: {
      ...(context === KHeaderWidgetComponentContext.Burger && {
        width: "calc(100vw - 5rem)",
        maxWidth: "15rem",
      }),
    },

    [`& .${classes.customLink}`]: {
      textDecoration: "none",
      display: "flex",
      alignItems: "center",
      "& .KIcon": {
        margin: "0.25rem",
      },
      padding: context === KHeaderWidgetComponentContext.Burger ? theme.spacing(1, 0) : 1,
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      alignSelf: "stretch",
      whiteSpace: "pre",
      "& + &": {
        marginLeft: context === KHeaderWidgetComponentContext.Burger ? 0 : 2,
      },
    },

    [`& .${classes.buttonHome}`]: {
      ...(context === KHeaderWidgetComponentContext.Burger && {
        padding: theme.spacing(1, 0),
        width: "100%",
        justifyContent: "left",
      }),
    },

    [`& .${classes.iconHome}`]: {
      ...(context === KHeaderWidgetComponentContext.Burger && {
        margin: theme.spacing(0.5),
      }),
    },

    [`& .${classes.searchBar}`]: {
      maxWidth: "450px",
      padding:
        context === KHeaderWidgetComponentContext.Burger
          ? theme.spacing(0, 0, 2, 0)
          : theme.spacing(0, 2.5),
    },

    [`& .${classes.user}`]: {
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
      ...(context === KHeaderWidgetComponentContext.Burger && {
        marginTop: theme.spacing(1, 0),
      }),
    },

    [`& .${classes.userTitle}`]: {
      display: "block",
      textAlign: "center",
      padding: theme.spacing(1, 0),
    },

    [`& .${classes.langSelector}`]: {
      ...(context === KHeaderWidgetComponentContext.Burger && {
        width: "100%",
        padding: theme.spacing(0, 0, 2, 0),
      }),
      minWidth: "5rem",

      ["& .MuiInput-root"]: {
        ["&::before"]: {
          borderBottome: "none",
          display: "none",
        },
      },

      ["& .MuiSelect-select"]: {
        fontWeight: 500,
        fontSize: "0.875rem",
        paddingBottom: theme.spacing(0.5),
        paddingTop: theme.spacing(0.5),
      },
    },
  }),
);

export default StyledKHeaderWidgetActionsBox;
